<template>
  <el-row>
    <el-table :data="collectionLogs" class="collection-logs" border style="width: 100%">
      <el-table-column prop="createdTime" label="时间" min-width="150">
        <template slot-scope="scope">
          <span :style="{ color: (scope.row.creatorName === '管理员' ? 'red' : '#333') }">{{
      formatTimestamp(scope.row.createdTime)
    }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contactTypeValue" label="联系方式" >
        <template slot-scope="scope">
          <span :style="{ color: (scope.row.creatorName === '管理员' ? 'red' : '#333') }">{{ scope.row.contactTypeValue
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contactName" label="联络人">
        <template slot-scope="scope">
          <span :style="{ color: (scope.row.creatorName === '管理员' ? 'red' : '#333') }">{{ scope.row.contactName
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contactPhone" label="联系电话" min-width="120">
        <template slot-scope="scope">
          <span :style="{ color: (scope.row.creatorName === '管理员' ? 'red' : '#333') }">{{ scope.row.contactPhone
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="relationValue" label="关系">

        <template slot-scope="scope">
          <span :style="{ color: (scope.row.creatorName === '管理员' ? 'red' : '#333') }">{{ scope.row.relationValue
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="callTypeValue" label="通话类型">

        <template slot-scope="scope">
          <span :style="{ color: (scope.row.creatorName === '管理员' ? 'red' : '#333') }">{{ scope.row.callTypeValue
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contactResultValue" label="通话结果">

        <template slot-scope="scope">
          <span :style="{ color: (scope.row.creatorName === '管理员' ? 'red' : '#333') }">{{ scope.row.contactResultValue
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contactStatusValue" label="联系状态">

        <template slot-scope="scope">
          <span :style="{ color: (scope.row.creatorName === '管理员' ? 'red' : '#333') }">{{ scope.row.contactStatusValue
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="overdueReasonValue" label="逾期原因">
        <template slot-scope="scope">
          <span :style="{ color: (scope.row.creatorName === '管理员' ? 'red' : '#333') }">{{ scope.row.overdueReasonValue
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remindeContent" label="催记内容" min-width="200">
        <template slot-scope="scope">
          <span :style="{ color: (scope.row.remindeContent === '管理员' ? 'red' : '#333') }">{{ scope.row.remindeContent
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="creatorName" label="催收人员">
        <template slot-scope="scope">
          <span :style="{ color: (scope.row.creatorName === '管理员' ? 'red' : '#333') }">{{ scope.row.creatorName
            }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-section">
      <el-pagination :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" :total="collectionLogsTotal"
        layout="total, sizes, prev, pager, next" @size-change="sizeChange" @current-change="changePage" />
    </div>
  </el-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'item-collection-log',
  props: {
    taskId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      pageSize: 5,
      page: 0
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'collectionLogs',
      'collectionLogsTotal',
      'borrowerInfo'
    ])
  },
  async created() {
    await this.fetchBorrowerInfo({ taskId: this.taskId })
    setTimeout(() => {
      this.fetchCollectionLogs({ contractNumber: this.borrowerInfo.contractNumber, page: this.page, size: this.pageSize, userId: this.currentUser.id || sessionStorage.getItem('userId') })
    }, 800)
  },
  methods: {
    ...mapActions([
      'fetchBorrowerInfo',
      'fetchCollectionLogs'
    ]),
    changePage(currentPage) {
      this.page = currentPage
      this.fetchCollectionLogs({ contractNumber: this.borrowerInfo.contractNumber, page: this.page, size: this.pageSize, userId: this.currentUser.id || sessionStorage.getItem('userId') })
    },
    sizeChange(size) {
      this.pageSize = size
      this.page = 0
      this.fetchCollectionLogs({ contractNumber: this.borrowerInfo.contractNumber, page: this.page, size: this.pageSize, userId: this.currentUser.id || sessionStorage.getItem('userId') })
    },
    // 将时间戳格式化为日期字符串
    formatTimestamp(timestamp) {
      const date = new Date(timestamp)
      // 获取年、月、日
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      // 获取小时、分钟、秒
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      // 拼接日期时间字符串
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-logs {
  margin-top: 15px;
}
</style>
